var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckEstrellas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85.27 62.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Check-estrellas_svg__Check-estrellas_svg__cls-1,.Check-estrellas_svg__Check-estrellas_svg__cls-2,.Check-estrellas_svg__Check-estrellas_svg__cls-9{fill:#fff}.Check-estrellas_svg__Check-estrellas_svg__cls-1,.Check-estrellas_svg__Check-estrellas_svg__cls-2{fill-rule:evenodd}.Check-estrellas_svg__Check-estrellas_svg__cls-1{opacity:.5;isolation:isolate}.Check-estrellas_svg__Check-estrellas_svg__cls-5,.Check-estrellas_svg__Check-estrellas_svg__cls-6,.Check-estrellas_svg__Check-estrellas_svg__cls-8{fill:none}.Check-estrellas_svg__Check-estrellas_svg__cls-5,.Check-estrellas_svg__Check-estrellas_svg__cls-6{stroke:#fff;stroke-width:.5px}.Check-estrellas_svg__Check-estrellas_svg__cls-7{fill:#639}.Check-estrellas_svg__Check-estrellas_svg__cls-8{stroke:#639}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Grupo_4751",
    "data-name": "Grupo 4751"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Trazado_3084",
    "data-name": "Trazado 3084",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-1",
    d: "M77 9c2.13 10.53.56 8.59 8.32 11.55-7.72 2.86-6.24.83-8.32 11.45-2.21-10.53-.64-8.5-8.4-11.45 7.62-2.96 6.14-.93 8.4-11.55z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Trazado_3085",
    "data-name": "Trazado 3085",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-2",
    d: "M52.93 0c1.11 5.49.29 4.48 4.34 6-4 1.5-3.23.44-4.34 6-1.15-5.49-.33-4.43-4.38-6 3.99-1.52 3.23-.46 4.38-6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Elipse_785",
    "data-name": "Elipse 785",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.16,
    cy: 21,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.16,
    cy: 21,
    r: 2.5,
    stroke: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Trazado_3086",
    "data-name": "Trazado 3086",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-1",
    d: "M5.67 32c1.43 7.1.37 5.79 5.59 7.78-5.16 1.93-4.17.56-5.59 7.72-1.5-7.1-.44-5.73-5.67-7.72 5.17-1.99 4.17-.62 5.67-7.78z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Grupo_4785",
    "data-name": "Grupo 4785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_469",
    "data-name": "L\\xEDnea 469",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-5",
    d: "M70.12 47.5v3.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_470",
    "data-name": "L\\xEDnea 470",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-5",
    d: "M65.66 51.96h3.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_471",
    "data-name": "L\\xEDnea 471",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-5",
    d: "M70.12 53.08v3.35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_472",
    "data-name": "L\\xEDnea 472",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-5",
    d: "M71.24 51.96h3.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_473",
    "data-name": "L\\xEDnea 473",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-6",
    d: "M66.97 48.81l2.36 2.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_474",
    "data-name": "L\\xEDnea 474",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-6",
    d: "M70.91 52.75l2.37 2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_475",
    "data-name": "L\\xEDnea 475",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-6",
    d: "M66.97 55.12l2.36-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_476",
    "data-name": "L\\xEDnea 476",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-6",
    d: "M70.91 51.17l2.37-2.36"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Elipse_784",
    "data-name": "Elipse 784"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-7",
    cx: 70.16,
    cy: 52,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-8",
    cx: 70.16,
    cy: 52,
    r: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Trazado_3087",
    "data-name": "Trazado 3087",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-2",
    d: "M31.76 56.43c.6 3 .16 2.41 2.34 3.24-2.16.8-1.74.23-2.34 3.21-.62-3-.18-2.39-2.36-3.21 2.15-.83 1.74-.26 2.36-3.24z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Grupo_4786",
    "data-name": "Grupo 4786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_469-2",
    "data-name": "L\\xEDnea 469-2",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-5",
    d: "M30.88 5.5v2.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_470-2",
    "data-name": "L\\xEDnea 470-2",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-5",
    d: "M27.66 8.72h2.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_471-2",
    "data-name": "L\\xEDnea 471-2",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-5",
    d: "M30.88 9.52v2.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_472-2",
    "data-name": "L\\xEDnea 472-2",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-5",
    d: "M31.68 8.72h2.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_473-2",
    "data-name": "L\\xEDnea 473-2",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-6",
    d: "M28.6 6.44l1.71 1.71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_474-2",
    "data-name": "L\\xEDnea 474-2",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-6",
    d: "M31.45 9.29l1.7 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_475-2",
    "data-name": "L\\xEDnea 475-2",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-6",
    d: "M28.6 10.99l1.71-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__L\\xEDnea_476-2",
    "data-name": "L\\xEDnea 476-2",
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-6",
    d: "M31.45 8.15l1.7-1.71"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Elipse_784-2",
    "data-name": "Elipse 784-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-7",
    cx: 30.9,
    cy: 8.74,
    r: 1.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-8",
    cx: 30.9,
    cy: 8.74,
    r: 0.94
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Grupo_4787",
    "data-name": "Grupo 4787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Trazado_2965-2",
    "data-name": "Trazado 2965-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-9",
    d: "M42.16 50.5a14.51 14.51 0 1110.25-4.25 14.41 14.41 0 01-10.25 4.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Check-estrellas_svg__Check-estrellas_svg__cls-9",
    d: "M42.16 22a14 14 0 109.9 4.1 13.92 13.92 0 00-9.9-4.1m0-1a15 15 0 11-15 15 15 15 0 0115-15z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Check-estrellas_svg__Check-estrellas_svg__Trazado_2966",
    "data-name": "Trazado 2966",
    d: "M35.66 35.74l4.45 4.76 8.25-8",
    stroke: "#306",
    strokeLinecap: "round",
    strokeWidth: 1.9,
    fill: "none"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEstrellas);
export default __webpack_public_path__ + "static/media/Check-estrellas.82e7489d.svg";
export { ForwardRef as ReactComponent };